import { Box, Heading, Text } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { useState } from "react";
import Helmet from "../containers/Helmet";
import FooterHotel from "../layout/FooterHotel";
import HeaderV3 from "../layout/HeaderV3";
import Section from "../layout/Section";
import { getFaq, getHotelBrands, getHotelDetail } from "../utils/api";
import { IHeader } from "../utils/types";

export default function ParadorFaq({
    header,
    hotelBrands,
    faqs,
}: {
    header: IHeader;
    hotelBrands: any;
    faqs: any[];
}) {
    const { locale } = useRouter();
    const [headerHeight, setHeaderHeight] = useState(0);
    const primaryColor: any = header.color_primary || "black";

    const unescapeHTML = (str: string) => {
        if (!str) return "";
        return str
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&amp;/g, "&")
            .replace(/&quot;/g, '"')
            .replace(/&#39;/g, "'");
    };

    return (
        <>
            <Helmet
                title={
                    locale == "id"
                        ? `FAQ | ${header.name}`
                        : `FAQ | ${header.name}`
                }
            />
            <HeaderV3
                headerItem={header}
                isHomepage={false}
                getHeight={(headerHeight: number) => setHeaderHeight(headerHeight)}
                hotelBrands={hotelBrands}
            />
            {/* <Box h={headerHeight} /> */}
            <Section>
                <Heading as="h1" mb={6} textAlign="center" color={primaryColor as any}>
                    {locale === "id" ? "Pertanyaan yang Sering Diajukan" : "Frequently Asked Questions"}
                </Heading>

                {faqs && faqs.length > 0 ? (
                    <Box>
                        {faqs.map((faq: any, index: number) => (
                            <Box key={index} mb={8} className="white-space-enter">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: unescapeHTML((locale === "id" ? faq.faq_id : faq.faq_en) ?? "")
                                    }}
                                />
                            </Box>
                        ))}
                    </Box>
                ) : (
                    <Text textAlign="center">
                        {locale === "id" ? "Tidak ada FAQ ditemukan." : "No FAQs found."}
                    </Text>
                )}
            </Section>

            <FooterHotel
                instagram={header.instagram}
                facebook={header.facebook}
                locationLink={header.location_url}
                location={header.location_long}
                email={header.email}
                phone={header.phone}
                bg={header.color_primary}
                color={header.color_secondary}
                logo={header.logo_light}
                hotelSlug={header.slug}
            />
        </>
    );
}

export async function getStaticProps({ locale }: any) {
    try {
        let temp;

        // Fetch Parador unit details (same as homepage)
        const data: any = await getHotelDetail({
            is_parador: "true",
            cct_status: "publish",
        }).then((r) => r.data?.[0]);

        if (!data) {
            return {
                notFound: true,
            };
        }


        temp = await data;

        // Fetch FAQs using the hotel slug which matches the FAQ hotel key 'parador'
        const faqData: any = await getFaq({
            hotel: data.slug,
            cct_status: "publish",
        }).then((r) => r.data).catch(() => []);


        if (locale == "id") {
            let x = JSON.stringify(data ?? "");
            let y = x.replace(/_id/g, "");
            temp = JSON.parse(y);
        } else {
            let x = JSON.stringify(data ?? "");
            let y = x.replace(/_en/g, "");
            temp = JSON.parse(y);
        }

        const {
            _ID = null,
            name = null,
            location_short = null,
            location_url = null,
            hotel_location = null,
            phone = null,
            logo_dark = null,
            logo_light = null,
            color_primary = null,
            color_secondary = null,
            is_parador = null,
            slug = null,
            hotel_code = null,
            hotel_sliders = null,
            location_short_en = null,
            has_dining = null,
            has_wedding = null,
            has_meeting_events = null,
            has_social_events = null,
            meeting_thumbnail = null,
            events_thumbnail = null,
            wedding_thumbnail = null,
            location_long = null,
            location_long_en = null,
            email = null,
            instagram = null,
            facebook = null,
        } = temp || {};

        const header: IHeader = {
            email: email ?? "",
            instagram: instagram ?? "",
            facebook: facebook ?? "",
            location_long: location_long ? location_long : location_long_en,
            id: _ID,
            name,
            color_primary,
            color_secondary,
            location: location_short ? location_short : location_short_en,
            location_url,
            hotel_location,
            phone,
            logo_dark,
            logo_light,
            is_parador: is_parador === "true",
            hotel_code: hotel_code == 0 ? null : hotel_code,
            slug,
            has_dining,
            has_wedding,
            has_meeting_events,
            has_social_events,
            meeting_thumbnail,
            events_thumbnail,
            wedding_thumbnail,
        };

        const hotelBrands = await getHotelBrands();

        return {
            props: {
                header,
                hotelBrands,
                faqs: faqData || [],
            },
            revalidate: parseInt(process.env.NEXT_PUBLIC_REVALIDATE_TIME ?? "200", 10), // In seconds
        };
    } catch (error) {
        console.error('Error in getStaticProps:', error);
        return {
            notFound: true,
        };
    }
}
